import { use as fegoUse } from '@fegobull/webapi';
import { computed } from 'vue-demi';

export function useFegoPageInfo() {
    const { useLang, usePageType } = fegoUse;
    const { langText } = useLang();
    const { isPC } = usePageType();

    const isCN = computed(() => langText === 'zh-cn');
    const isHK = computed(() => langText === 'zh-hk');
    const isEN = computed(() => langText === 'en-us');

    const kls = computed(() => [
        isPC ? 'is-pc' : 'is-mobile',
        isHK ? 'is-hk' : '',
        isEN ? 'is-en' : '',
        isCN ? 'is-cn' : '',
    ]);

    return {
        kls, isPC, isCN, isHK, isEN,
    };
}

/**
 * 根据当前语言从 stockInfo 中选择展示名称
 * - 简体：scName
 * - 繁体：tcName
 * - 英文：shortName
 * 说明：返回 fallback 作为兜底，避免出现空白
 */
export function getStockNameByLang(stockInfo, lang = {}, fallback = '-') {
    const info = stockInfo || {};
    const scName = info?.scName ? String(info.scName) : '';
    const tcName = info?.tcName ? String(info.tcName) : '';
    const shortName = info?.shortName ? String(info.shortName) : '';
    const name = info?.name ? String(info.name) : '';

    if (lang.isEN) return shortName || name || tcName || scName || fallback;
    if (lang.isHK) return tcName || scName || shortName || name || fallback;
    if (lang.isCN) return scName || tcName || shortName || name || fallback;
    return scName || tcName || shortName || name || fallback;
}

/**
 * 根据语言拼接“股票名称 + 现价”文案
 * - 简体：{name}现价
 * - 繁体：{name}現價
 * - 英文：{name} Price
 */
export function getCurrentPriceLabelByLang(name = '-', lang = {}) {
    const n = name != null ? String(name) : '-';
    if (lang.isEN) return `${n} Price`;
    if (lang.isHK) return `${n}現價`;
    if (lang.isCN) return `${n}现价`;
    return `${n}現價`;
}

export function useCommon(config = {}) {
    const { loginConf = {} } = config;

    const { useBehaviour } = fegoUse;
    const { runBehaviour } = useBehaviour();

    const toLogin = () => {
        runBehaviour(null, {
            type: 'login',
            withQuery: true,
            ...loginConf || {},
            extendParams: {
                ...loginConf.extendParams || {}
            },
            option: {
                ...loginConf.options || {}
            }
        });
    };

    return {
        toLogin,
    };
}
